module.exports = __webpack_public_path__ + "img/ship.67e79799.jpeg";